<template>
  <div class="goodsInfo">
    <div class="topCon">
      <!-- <Anti /> -->
    </div>
    <!-- <div class="pageContentRef_index">
      <Tem />
      <Enterprise />
      <Tradeinfo />
      <QualityTesting />
      <diy2 />
    </div> -->
    <van-collapse v-model="activeNames">
      <div>
        <van-collapse-item
          :name="index"
          v-for="(item, index) in listDataAll2"
          @click.native="hRender(item)"
          :key="index"
        >
          <template #title>
            <div class="top">
              <img src="../assets/images/头部信息框.png" alt="" />
              <div
                class="heyan"
                @click.stop="hy"
                v-if="item.trace_name === '溯源证书'"
              >
                去核验
              </div>
              <div class="info">
                <span>{{ item.trace_name }}</span>
              </div>
              <div class="num">
                <span>{{ index + 1 }}</span>
              </div>
            </div>
          </template>
          <security v-if="item.trace_name === '溯源证书'" />

          <Tem v-if="item.trace_name === '商品信息'" />
          <Enterprise v-if="item.trace_name === '企业信息'" :pyInfo="pyInfo" />
          <div v-if="item.trace_name === '防伪信息'">
            <Anti :fwInfo="fwInfo" />
            <!-- <security :fwInfo="fwInfo" /> -->
          </div>

          <Tradeinfo v-if="item.trace_name === '交易信息'" :jyInfo="jyInfo" />
          <!-- <Tem v-if="item.trace_name === '商品信息'" :temInfo="TemInfo" /> -->
          <DigitalAsset
            v-if="item.trace_name === '数字资产'"
            :digitalAssetInfo="digitalAssetInfo"
          />
          <QualityTesting
            v-if="item.trace_name === '质检信息'"
            :zjInfo="zjInfo"
          />
          <storage v-if="item.trace_name === '仓储信息'" :czInfo="czInfo" />
          <diy2 v-if="isNaN(Number(item.trace_id))" :dataList="item" />
        </van-collapse-item>
      </div>
    </van-collapse>
    <footers />
    <bottom />
    <div class="arDiv">
      <Advertising />
      <Rewards />
    </div>
    <!-- <div
      v-for="(item, index) in listDataAll"
      :key="index"
      :id="'trace' + index"
      class="pageContentRef_index"
    >
      <Anti info="防伪信息" v-if="item.trace_name === '防伪信息'" />
      <Tem v-if="item.trace_name === '商品信息'" />
      
      <Tradeinfo v-if="item.trace_name === '流通信息'" />
      <QualityTesting v-if="item.trace_name === '质检信息'" />
      <diy2 v-if="isNaN(Number(item.trace_id))" :dataList="item" />
    </div> -->
    <!-- <ewm /> -->
    <!-- <van-overlay :show="show" @click="show = false">
      <div class="wrapper">
        <div class="block">
          <div class="t-info">张晓霞先生</div>
          <div></div>
          <div class="f-info">欢迎您使用我们的链白茶产品， 再接下来我们与您同在</div>
        </div>
      </div>
    </van-overlay> -->
  </div>
</template>
<script>
import Vue from "vue";

import { Toast } from "vant";
import { Overlay } from "vant";
import { Collapse, CollapseItem } from "vant";
// import axios from "axios";

Vue.use(Overlay);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Toast);
// import PageContent from "../components/templateContent";
// import MapCp from "../components/map.vue";
// import SecurityInfo from "./SecurityInfo.vue";
// import EnterpriseInfo from "@/views/EnterpriseInfo";
// import QsInfo from "@/views/QsInfo";
// import CirculationInfo from "@/views/CirculationInfo";
// import Intelligent from "@/views/Intelligent";
// import PlantInfo from "@/views/PlantInfo";
import Anti from "./anti-fake.vue";
import bottom from "./bottom.vue";
import footers from "./footer.vue";
import Advertising from "./advertising.vue";
import Rewards from "./rewards.vue";
import Tem from "./tem.vue";
import Enterprise from "./enterprise.vue";
import QualityTesting from "./qualityTesting.vue";
// import ewm from "./ewm.vue";
import Tradeinfo from "./Tradeinfo.vue";
import storage from "./storage.vue";
import security from "./security.vue";
// import Diy from './diy.vue';
import axios from "axios";
import Diy2 from "./diy2.vue";
import DigitalAsset from "./digitalAsset.vue";
// import Test from './test.vue';
export default {
  computed: {
    getShopImageList() {
      return function (obj) {
        if (!obj) {
          return [];
        } else if (typeof obj[0] == "string") {
          return obj;
        } else if (typeof obj[0] == "object") {
          return obj.map((v) => {
            return v.url;
          });
        }
      };
    },
  },
  components: {
    // PageContent,
    // MapCp,
    // SecurityInfo,
    // EnterpriseInfo,
    // QsInfo,
    // CirculationInfo,
    // Intelligent,
    // PlantInfo,
    Anti,
    Advertising,
    Rewards,
    Tem,
    Enterprise,
    QualityTesting,
    // ewm,
    footers,
    Tradeinfo,
    security,
    // Diy,
    Diy2,
    DigitalAsset,
    bottom,
    storage,
    // Test,
  },
  data() {
    let that = this;
    return {
      fwInfo: {},
      TemInfo: {},
      pyInfo: {},
      zjInfo: {},
      czInfo: {},
      jyInfo: {},
      digitalAssetInfo: {},
      ylId: "",
      activeNames: [0],
      show: null,
      indexswiper: 0,
      testImage:
        "https://ss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=3957346327,171699722&fm=15&gp=0.jpg",
      listData: {},
      isShowiMmage: true,
      materialData: {},
      lats: 13,
      longs: 13,
      swiperOption: {
        // loop: true,
        // speed: oriSpeed,
        slidesPerView: "auto",
        freeMode: true,
        direction: "vertical",
        setWrapperSize: true,
        autoHeight: true,
        on: {
          touchMove() {
            const index =
              that.$refs.mySwiper_.swiper.activeIndex >
              that.listDataAll.length - 1
                ? that.listDataAll.length - 1
                : that.$refs.mySwiper_.swiper.activeIndex;
            that.$store.commit("setMeunIndex", index);
          },
          transitionEnd() {
            if (that.$refs.mySwiper_.swiper) {
              const index =
                that.$refs.mySwiper_.swiper.activeIndex >
                that.listDataAll.length - 1
                  ? that.listDataAll.length - 1
                  : that.$refs.mySwiper_.swiper.activeIndex;
              that.$store.commit("setMeunIndex", index);
            }
          },
        },
        // autoplayDisableOnInteraction: false,
      },
      listDataAll: [],
      listDataAll2: [],
    };
  },
  async created() {},
  mounted() {
    try {
      this.$setApptitle("链白茶防伪溯源");
    } catch {
      console.log("not webview");
    }
    this.listDataAll = JSON.parse(localStorage.getItem("defalutObj"));

    console.log(this.listDataAll, "listDataAll");

    this.listDataAll = this.listDataAll.filter((item) => item.chain_id);

    // this.listDataAll = this.listDataAll.sort((a, b) => {
    //   return a.sort - b.sort;
    // });

    this.listDataAll.forEach((item) => {
      if (item.trace_name == "原料环节") {
        this.ylId = item.chain_id;
      }
    });

    this.listDataAll2 = this.listDataAll.filter(
      (item) => item.trace_name !== "原料环节"
    );
    this.listDataAll2 = this.listDataAll2.filter(
      (item) => item.is_display == 1
    );
    console.log(this.listDataAll2, "mmmmm");

    // 获取原料环节;
    // this.materialData = JSON.parse(window.localStorage.getItem("idInObj"))[0];
    // const toast = Toast.loading({
    //   duration: 0, // 持续展示 toast
    //   forbidClick: true,
    //   message: "查询中",
    // });
    // window.addEventListener("scroll", this.upDateTop_index, true);
    // this.$bus.on("menuSetBus", (id) => {
    //   let scrollDom = document.getElementById(id);
    //   let scrollDombox = document.getElementsByClassName("leftContainer")[0];
    //   let scrollDomboxTop = scrollDombox.scrollTop;
    //   let scrollDomTop = scrollDom.getBoundingClientRect().top;
    //   let scroll = Number(scrollDomTop) + Number(scrollDomboxTop) - 45;
    //   document.getElementsByClassName("leftContainer")[0].scrollTop = scroll;
    // });
    // setTimeout(() => {
    //    this.show = false
    // }, 3000);
  },
  methods: {
    // 渲染模块
    hRender(item) {
      console.log(isNaN(Number(item.trace_id)));

      if (isNaN(Number(item.trace_id))) {
        return;
      }
      if (item.trace_name == "溯源证书") {
        return;
      }

      // console.log(chain_id);
      let chain_id = [];
      if (item.trace_name == "商品信息") {
        chain_id.push(item.chain_id, this.ylId);
      } else {
        chain_id.push(item.chain_id);
      }
      let data = {
        chain_id,
        chipData: localStorage.getItem("key"),
        merchant_id: localStorage.getItem("enterprise_merchant_id"),
      };
      // this.$api.GetScanTrace(data).then((res) => {
      //   if (res.data.code == 200) {
      //     if (item.trace_name == "商品信息") {
      //       this.TemInfo = JSON.parse(res.data.data);
      //     } else if (item.trace_name == "企业信息") {
      //       this.pyInfo = JSON.parse(res.data.data);
      //     } else if (item.trace_name == "质检信息") {
      //       this.zjInfo = JSON.parse(res.data.data);
      //     } else if (item.trace_name == "交易信息") {
      //       this.jyInfo = JSON.parse(res.data.data);
      //     }
      //   } else {
      //     Toast(res.data.msg);
      //   }
      // });
      axios
        .post(
          "https://apigateway.klyun.com.cn/chain/chainindustry/v1.0.0/ScanTrace/GetScanTrace",
          // "https://sitapigateway.v-m.site/chain/chainindustry/v1.0.0/ScanTrace/GetScanTrace",
          data
        )
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            if (item.trace_name == "防伪信息") {
              this.fwInfo = JSON.parse(res.data.data);
            } else if (item.trace_name == "企业信息") {
              this.pyInfo = JSON.parse(res.data.data);
            } else if (item.trace_name == "质检信息") {
              this.zjInfo = JSON.parse(res.data.data);
            } else if (item.trace_name == "交易信息") {
              this.jyInfo = JSON.parse(res.data.data);
            } else if (item.trace_name == "数字资产") {
              this.digitalAssetInfo = JSON.parse(res.data.data);
            } else if (item.trace_name == "仓储信息") {
              this.czInfo = JSON.parse(res.data.data);
            }
          } else {
            Toast(res.data.msg);
          }
        });
    },
    hy() {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      let listDataAll = JSON.parse(window.localStorage.getItem("defalutObj"));
      let list = listDataAll.filter((item) => item.trace_name === "溯源证书");
      list.forEach((item) => {
        list = item.msgItems;
      });
      let syList = list[0].op.op;
      let verification_chain_id = "";
      syList.forEach((item) => {
        if (item.title == "区块链标识") {
          verification_chain_id = item.example;
        }
      });
      console.log(verification_chain_id);
      let data = {
        verification_chain_id,
        merchant_id: localStorage.getItem("enterprise_merchant_id"),
      };
      axios
        .post(
          // https://sitapigateway.v-m.site/chaintea/
          // "https://apigateway.klyun.com.cn/chain/chainindustry/v1.0.0/ScanTrace/GetScanTrace",
          "https://apigateway.klyun.com.cn/chain/chainindustry/v1.0.0/ScanTrace/Verification",
          data
        )
        .then((res) => {
          if (res.data.code == 200) {
            console.log(res);
            Toast(res.data.msg);
            this.$router.push(`/success?s=${1}`);
          } else {
            Toast(res.data.msg);
            this.$router.push(`/success?s=${2}`);
          }
        });
    },
    upDateTop_index() {
      let doms = document.getElementsByClassName("pageContentRef_index");
      let indexSilder = 0;
      for (let i = 0; i < doms.length; i++) {
        let thatDomTopVlalue = doms[i].getBoundingClientRect().bottom;
        if (thatDomTopVlalue > 45) {
          indexSilder = i;
          break;
        }
      }
      if (!this.$store.state.isClickMenu) {
        this.$store.commit("setMeunIndex", indexSilder);
        this.$store.commit("isClickMeunHandle", false);
      }
    },
  },
};
</script>
<style>
.van-collapse-item {
  margin-bottom: 30px;
}
</style>
<style lang="scss" scoped>
.top {
  position: relative;
  width: 614px;
  height: 100px;
  img {
    width: 100%;
    height: 100%;
  }
  .heyan {
    position: absolute;
    top: 5vw;
    left: 62vw;
    font-size: 32px;
    color: #127855;
  }

  .info {
    position: absolute;
    top: 9vw;
    left: 6vw;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 0px;
    color: #fff;
    opacity: 1;
  }
  .num {
    color: transparent;
    -webkit-text-stroke: 1px #127855;
    font-size: 11vw;
    position: absolute;
    top: 15px;
    left: 240px;
  }
}
div {
  box-sizing: border-box;
}
.title-navToptitle {
  padding: 0 20px;
}

::v-deep .van-swipe-item {
  .imagebg {
    width: 530px;
    height: 530px;
    // border-radius: 16px;
    // background: url("https://ss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=3957346327,171699722&fm=15&gp=0.jpg")
    //   no-repeat;
    background-size: contain;
    background-position: center center;
  }
}
::v-deep .swipe {
  border-radius: 15px;
}
.goodsInfo {
  width: 100%;
  .topCon {
    padding: 36px 32px;
    width: 100%;
    background-color: #fff;
    margin-bottom: 30px;
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .arDiv {
    // margin: 138px auto;
    width: 100%;
    margin-bottom: 600px;
  }
  .block {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .t-info {
      text-align: center;
      width: 280px;
      height: 80px;
      line-height: 80px;
    }
    .f-info {
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 52px;
      color: #ffffff;
      opacity: 1;
      text-align: center;
      width: 392px;
      height: 92px;
      // margin-bottom: 166px;
    }
    width: 554px;
    height: 646px;

    background-image: url("../assets/images/欢迎弹窗.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .content {
    font-family: PingFang SC;
    line-height: 46px;
    color: #222;

    .info-wrap {
      padding: 0 0 16px 30px;
      border-bottom: 1px solid #d4d6d5;
      font-family: PingFang SC;
      line-height: 34px;
      position: relative;

      .tle {
        margin: 20px 0;
        font-size: 28px;
        font-weight: bold;
      }

      .info {
        color: #808080;
      }

      &::before {
        content: "";
        position: absolute;
        top: 11px;
        left: 0;
        background-color: #26907a;
        width: 8px;
        height: 8px;
      }
    }
  }
}
.goods-info-box {
  width: 100%;
  .goods-info-fold-title {
    width: 100%;
    height: 96px;
    background-color: #f5f5f5;
    box-shadow: 0px 4px 8px rgba(0, 45, 41, 0.2);
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    padding: 24px 20px;

    .goods-info-fold-left {
      font-size: 34px;
      color: #222;
      display: flex;
      align-items: center;
      height: 100%;
      .info-fold-line {
        width: 8px;
        height: 34px;
        background-color: #26907a;
        margin-right: 16px;
      }
    }
    .goods-info-fold-right {
      font-size: 26px;
      color: #11745f;
      display: flex;
      span {
        margin-right: 8px;
      }
      align-items: center;
      .info-fold-right-image {
        width: 20px;
        height: 20px;
        transition: all 0.2s;

        img {
          transition: all 0.2s;
          width: 100%;
          height: 100%;
        }
      }
    }
    .to-page {
      width: 20px;
      height: 64px;
      // background-color: skyblue;
      position: absolute;
      bottom: -40px;
      z-index: 999;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .to-page.right {
      right: 10px;
    }
    .topage.left {
      left: 0;
    }
  }
}

.goods-info-fold-newtitle-box {
  width: 100%;
  height: auto;

  // padding-bottom: 60px;
  transition: all 0.3s;
  .goods-info-fold-innertitle {
    width: 100%;
    height: 112px;
    // box-shadow: 0px 4px 8px rgba(0, 45, 41, 0.2);
    border-radius: 16px;
    background-color: #f5f5f5;

    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 20px;
    position: relative;
    .goods-info-fold-left {
      font-size: 30px;
      color: #11745f;
      display: flex;
      height: 100%;
      align-items: center;
      .info-fold-img {
        width: 40px;
        height: 40px;
        img {
          width: 100%;
          height: 100%;
        }
        margin-right: 16px;
      }
    }
    .goods-info-fold-right {
      font-size: 26px;
      color: #11745f;

      .info-fold-right-image {
        width: 20px;
        height: 20px;
        transform: rotate(-180deg);
        transition: all 0.2s;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  // 具体盒子内容部分
  .goods-info-content {
    width: 100%;
    // height: ;
    padding-top: 48px;
    .goods-info-content-image {
      // padding: 0 40px;
      width: 530px;
      margin: 0 auto;
      // display: flex;
      // margin: 0 auto;
      // justify-content: center;
    }
  }
}
.goods-info-inner-box {
  overflow: hidden;
  transition: all 0.2s;
  margin-top: 20px;
  // padding-bottom: 20px;
}

.goods-info-fold-innertitle.active {
  // border-bottom: 1px dashed #BCBCBC;
  box-shadow: none;
  border-radius: 0;
}
.goods-info-fold-innertitle.active::before {
  content: "";
  width: 92%;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
  // background-color: pink;
  border-bottom: 1px dashed #bcbcbc;
  height: 1px;
}
.goods-info-collapse {
  border-radius: 16px;
  box-shadow: 0px 4px 8px rgba(0, 45, 41, 0.2);
  position: relative;
  background-color: #f5f5f5;
  z-index: 10;
}

.goods-content-allbox {
  overflow: hidden;
  transition: all 0.2s;
}
.image-alert {
  img {
    width: 300px;
    height: 300px;
  }
}
.info-wrap.qitainfo {
  border: none !important;
}
.qitainfo {
  padding: 0 0 16px 0 !important;
  .info {
    padding-left: 30px !important;
  }
}
.qitatitle {
  padding: 0 0 0 30px !important;
}

.map_box {
  width: 100%;
  height: 320px;
  // background-color: pink;
}
// .swiper-slide {
//   width: auto !important;
// }
.swiper-slide {
  text-align: center;
  font-size: 18px;
  width: 100%;
  // height: 200px;
  // max-height: calc(100vh - 88px);
  height: auto !important;
  position: relative;
  /* Center slide text vertically */
}
.swiper_right {
  height: 100vh !important;
}
</style>
